import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

interface HeaderProps {
  onMenuToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuToggle }) => {
  const { user } = useAuth();

  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-toggle" aria-label="Toggle Menu" onClick={onMenuToggle}>
          <i className="lni lni-menu"></i>
        </button>
        <div className="logo">
          <h1>CGH</h1>
        </div>
      </div>
      <div className="header-right">
        <div className="welcome">
          <h2>Welcome Back, <b>{user?.nickname || 'Guest'}</b></h2>
        </div>
      </div>
    </header>
  );
};

export default Header; 